import { ref, reactive, onMounted, toRefs } from "vue";
import { getCurrentInstance } from "vue";
import LoginLog from "./LogComponents/LoginLogComponent";
import RequestLog from "./LogComponents/RequestLogComponent";
export default {
  components: {
    LoginLog,
    RequestLog
  },
  name: "LogSetting",
  methods: {},
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const data = reactive({
      tabsValue: "first"
    });
    onMounted(() => {});
    return {
      ...toRefs(data),
      proxy
    };
  }
};